import React, { useState, useEffect, useRef } from 'react';
import { supabase } from '../lib/supabase';

const DiagnosticAuth = () => {
  const [email, setEmail] = useState('seeker1@boholtrabaho.app');
  const [password, setPassword] = useState('123123');
  const [loading, setLoading] = useState(false);
  const [logs, setLogs] = useState([]);
  const logsEndRef = useRef(null);

  const addLog = (message, type = 'info') => {
    const timestamp = new Date().toLocaleTimeString();
    setLogs(prev => [...prev, { timestamp, message, type }]);
    console.log(`[${timestamp}] ${message}`);
  };

  useEffect(() => {
    logsEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [logs]);

  useEffect(() => {
    addLog('🚀 Diagnostic Auth page loaded', 'success');
    addLog(`Supabase URL: ${process.env.REACT_APP_SUPABASE_URL}`);
    addLog(`Backend URL: ${process.env.REACT_APP_BACKEND_URL}`);
    checkSupabaseConnection();
  }, []);

  const checkSupabaseConnection = async () => {
    try {
      addLog('🔍 Checking Supabase connection...');
      const { data, error } = await supabase.auth.getSession();
      if (error) {
        addLog(`❌ Session check error: ${error.message}`, 'error');
      } else {
        addLog('✅ Supabase connection OK', 'success');
        if (data.session) {
          addLog(`✅ Existing session found for: ${data.session.user.email}`, 'success');
        }
      }
    } catch (err) {
      addLog(`❌ Connection failed: ${err.message}`, 'error');
    }
  };

  const handleSignIn = async (e) => {
    e.preventDefault();
    setLoading(true);
    addLog('🔐 Starting sign-in process...');
    
    try {
      addLog(`📧 Email: ${email}`);
      addLog('🔑 Password: ***');
      
      addLog('⏳ Calling supabase.auth.signInWithPassword...');
      const startTime = Date.now();
      
      const { data, error } = await supabase.auth.signInWithPassword({
        email: email,
        password: password,
      });
      
      const elapsed = Date.now() - startTime;
      addLog(`⏱️ Sign-in API took ${elapsed}ms`);

      if (error) {
        addLog(`❌ Sign-in error: ${error.message}`, 'error');
        addLog(`Error details: ${JSON.stringify(error)}`, 'error');
        throw error;
      }

      addLog('✅ Sign-in successful!', 'success');
      addLog(`User ID: ${data.user?.id}`);
      addLog(`User email: ${data.user?.email}`);
      
      addLog('🔍 Checking session after sign-in...');
      const { data: sessionData } = await supabase.auth.getSession();
      addLog(`Session valid: ${!!sessionData.session}`, 'success');
      
      addLog('✅ ALL CHECKS PASSED - Sign-in working!', 'success');
      
    } catch (error) {
      addLog(`❌ FAILED: ${error.message}`, 'error');
      addLog(`Stack: ${error.stack}`, 'error');
    } finally {
      setLoading(false);
      addLog('🏁 Sign-in process completed');
    }
  };

  const clearLogs = () => {
    setLogs([]);
    addLog('🧹 Logs cleared');
  };

  return (
    <div style={{
      fontFamily: 'monospace',
      padding: '20px',
      backgroundColor: '#1a1a1a',
      minHeight: '100dvh',
      color: '#00ff00'
    }}>
      <h1 style={{ color: '#00ff00', marginBottom: '20px' }}>
        🔧 Diagnostic Sign-In Test
      </h1>

      <div style={{
        backgroundColor: '#2a2a2a',
        padding: '20px',
        borderRadius: '8px',
        marginBottom: '20px'
      }}>
        <form onSubmit={handleSignIn}>
          <div style={{ marginBottom: '10px' }}>
            <label style={{ display: 'block', marginBottom: '5px' }}>Email:</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={{
                width: '100%',
                padding: '10px',
                fontSize: '16px',
                backgroundColor: '#1a1a1a',
                color: '#00ff00',
                border: '1px solid #00ff00',
                borderRadius: '4px'
              }}
            />
          </div>

          <div style={{ marginBottom: '10px' }}>
            <label style={{ display: 'block', marginBottom: '5px' }}>Password:</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{
                width: '100%',
                padding: '10px',
                fontSize: '16px',
                backgroundColor: '#1a1a1a',
                color: '#00ff00',
                border: '1px solid #00ff00',
                borderRadius: '4px'
              }}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{
              padding: '12px 24px',
              fontSize: '16px',
              backgroundColor: loading ? '#555' : '#00aa00',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              cursor: loading ? 'not-allowed' : 'pointer',
              width: '100%',
              marginBottom: '10px'
            }}
          >
            {loading ? '⏳ Signing in...' : '🔐 Sign In'}
          </button>

          <button
            type="button"
            onClick={clearLogs}
            style={{
              padding: '8px 16px',
              fontSize: '14px',
              backgroundColor: '#333',
              color: '#fff',
              border: '1px solid #555',
              borderRadius: '4px',
              cursor: 'pointer',
              width: '100%'
            }}
          >
            🧹 Clear Logs
          </button>
        </form>
      </div>

      <div style={{
        backgroundColor: '#0a0a0a',
        padding: '15px',
        borderRadius: '8px',
        maxHeight: '500px',
        overflowY: 'auto',
        border: '1px solid #00ff00'
      }}>
        <h3 style={{ marginTop: 0, marginBottom: '10px', color: '#00ff00' }}>
          📋 Console Logs:
        </h3>
        {logs.map((log, index) => (
          <div
            key={index}
            style={{
              padding: '5px',
              marginBottom: '5px',
              borderLeft: `3px solid ${
                log.type === 'error' ? '#ff0000' : 
                log.type === 'success' ? '#00ff00' : '#ffaa00'
              }`,
              paddingLeft: '10px',
              color: log.type === 'error' ? '#ff6666' : '#00ff00',
              fontSize: '13px',
              overflowWrap: 'break-word',
              wordBreak: 'break-word'
            }}
          >
            <span style={{ color: '#888' }}>[{log.timestamp}]</span> {log.message}
          </div>
        ))}
        <div ref={logsEndRef} />
      </div>

      <div style={{
        marginTop: '20px',
        padding: '15px',
        backgroundColor: '#2a2a2a',
        borderRadius: '8px',
        fontSize: '12px',
        color: '#888'
      }}>
        <strong>Instructions:</strong>
        <ul>
          <li>This page logs every step of the sign-in process</li>
          <li>Watch the logs to see where it hangs</li>
          <li>If it hangs, you'll see which step never completes</li>
          <li>Access this page at: <strong>/diagnostic-auth</strong></li>
        </ul>
      </div>
    </div>
  );
};

export default DiagnosticAuth;
